import { render } from "./AuditOverview.vue?vue&type=template&id=35d0f530"
import script from "./AuditOverview.vue?vue&type=script&lang=js"
export * from "./AuditOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__